import { defineMessages } from 'react-intl';

// eslint-disable-next-line import/no-default-export
export default defineMessages({
    greeting: {
        id: '_.outstanding_view.greeting',
        defaultMessage: 'Hello, {name}'
    },
    yourlookingat: {
        id: '_.outstanding_view.yourlookingat',
        defaultMessage: `You're looking at your`
    },
    overviewTab: {
        id: '_.outstanding_view.overviewTab',
        defaultMessage: 'Overview'
    },
    repaymentsTab: {
        id: '_.outstanding_view.repaymentsTab',
        defaultMessage: 'Repayments'
    }
});
